import _ from 'lodash';

import { coins, coinDesc } from '@/api/const';
import blockchain, { getQuotes } from '@/api/blockchain';

export default {
  namespaced: true,
  state: {
    ..._.chain(coins).map(c => [c, { ...coinDesc[c], hashrate: 0 }]).fromPairs().value()
  },
  getters: {
    getCoin(state) {
      return coin => ({ hashrate: 0, price: 0, percentChange24h: 0, miningEarning: 0, totalReward24h: 0, ...state[coin] });
    }
  },
  mutations: {
    update(state, networkInfo) {
      Object.assign(state[networkInfo.coin], networkInfo);
    }
  },
  actions: {
    async load({ commit, dispatch }) {
      for (const q of await getQuotes()) {
        commit('update', q);
      }

      for (const c of coins) {
        commit('update', await blockchain[c].getNetworkInfo());
      }

      dispatch('cloudMining/load', null, { root: true });
      dispatch('contracts/load', null, { root: true });
    }
  }
};